module.exports = __webpack_public_path__ + "img/default.952aeb5b.png";